import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

const presentationCards = [
  {
    key: 'size_130',
    keyDesc: 'size_130_desc',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/45e713ad-8aa6-432b-8877-3a6c08e7d16f_compressed_Fresa130g.webp',
  },
  {
    key: 'size_440',
    keyDesc: 'size_440_desc',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/4bb8ff6c-ed41-4a0b-853a-c15492cb6b4f_compressed_BaseCoco440g.webp',
  },
  {
    key: 'size_950',
    keyDesc: 'size_950_desc',
    imageUrl: 'https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/39b514d3-1166-4689-8404-d93b79d64b5a_compressed_Vainilla950g.webp',
  },
];

export default function PresentationsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="presentaciones" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 opacity-[0.03]">
          <div className="flex justify-center gap-8">
            {Array.from({ length: 15 }).map((_, i) => (
              <div key={i} className="w-8 h-8 border border-primary-400 rounded-full"></div>
            ))}
          </div>
        </div>
        <div className="absolute -right-16 top-1/3 opacity-[0.05]">
          <div className="w-36 h-72 border border-primary-400 rounded-t-full"></div>
        </div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div ref={ref} className={`scroll-reveal text-center mb-16 ${isVisible ? 'visible' : ''}`}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            {t('presentations.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {presentationCards.map((pres, idx) => (
            <div
              key={pres.key}
              className={`scroll-reveal group bg-background-50 rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-2`}
              style={{ transitionDelay: `${idx * 120}ms` }}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-white">
                <img
                  src={pres.imageUrl}
                  alt={t(`presentations.${pres.key}`)}
                  className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6 md:p-8 text-center">
                <span className="inline-block font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-3">
                  {t(`presentations.${pres.key}`)}
                </span>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  {t(`presentations.${pres.keyDesc}`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}